<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>
<style>
body {
  overflow: auto;
  min-width: 1280px;
  font-size: 14px;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, SimHei, Arial, sans-serif;
}

html, body, #app {
  height: 100%;
}

.table-list .el-table th.is-leaf {
  background: rgba(250, 250, 250, 1);
  border-top: 1px solid #EBEEF5;
}

.menu-content {
  margin: 0 20px 20px 20px;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  background: #FFFFFF;
  overflow: auto;
  position: absolute;
  left: 250px;
  top: 115px;
  bottom: 0;
  right: 0;
  padding: 20px;
  border-radius: 3px;
}

.page-box {
  text-align: center;
  margin-top: 20px;
}

.table-list .el-table  th {
  font-size: 15px;
  color: #666666;
}

::-webkit-scrollbar {/*滚动条整体样式*/
  width: 8px;     /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}

::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px #c7cace;
  background: #c7cace;
}

::-webkit-scrollbar-track { /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px transparent;
  border-radius: 0;
  background: transparent;
}

.close-icon-box{
  float: right;
  display: inline-block;
  line-height: 35px!important;
  cursor: pointer;
}

.close-icon-box:hover{
  color: var(--color-primary);
}
</style>
